import React from "react";
import "./style/image-grid.css";
import BlackAndWhiteImg from "../atoms/BlackAndWhiteImg";
import ZeccaVecchia from "../atoms/ZeccaVecchia";
import ViaMazzini from "../atoms/ViaMazzini";
import Box2 from "../atoms/Box2";
import AboutNecklace from "../atoms/about-necklace";

const AboutImageGrid = () => {
	return (
		<div className="about-image-grid" style={{ paddingTop: 20 }}>
			<div
				className="about-right-image-box"
				style={{ width: "100%", marginLeft: 0 }}
			>
				<div className="mb-image">
					<BlackAndWhiteImg />
				</div>
				<div className="left-paragraph">
					<p className="text">
						Welcome to the fascinating story of our goldsmith company, a project
						born in the heart of Milan in 1960. <br />
						Founded by a young and passionate goldsmith named Giovanni, my
						father, the company originated in Piazza Borromeo, the pulsating
						heart of the city. <br />
					</p>
					<p className="text">
						From the outset, our business stood out for its dedication to the
						art of goldsmithing and the creation of unique jewelry. <br />
						The first steps were taken in a charming workshop with an office
						that offered a breathtaking view of historic Piazza Borromeo,
						surrounded by buildings owned by the count Borromeo family.
					</p>
				</div>
				<div className="dk-image">
					<BlackAndWhiteImg />
				</div>
			</div>
			<div
				className="about-left-image-box"
				style={{ width: "100%", marginRight: 0, justifyContent: "flex-start" }}
			>
				<AboutNecklace />
				<div className="right-paragraph">
					<p className="text">
						The subsequent decades witnessed the constant growth of the
						business, with the conquest of an increasingly vast and diversified
						clientele. <br />
						Among our clients were also prestigious names in fashion, who
						entrusted us with the creation of exclusive jewelry for their
						renowned clothing lines. <br />
					</p>
				</div>
			</div>
			<div
				className="about-right-image-box"
				style={{ width: "100%", marginLeft: 0 }}
			>
				<div className="mb-image">
					<ZeccaVecchia />
				</div>
				<div className="left-paragraph">
					<p className="text">
						In the '90s, the baton passed to me, Nicola, who decided to move the
						workshop to a new and enchanting location: this time, a street-front
						showcase just steps away from Piazza Borromeo, precisely in Via
						Zecca Vecchia, inside a historic building dating back to 1400.{" "}
						<br />
						The operation proved to be a success, allowing me to introduce my
						creations to the wealthy private clientele of the historic center of
						Milan.
					</p>
				</div>
				<div className="dk-image">
					<ZeccaVecchia />
				</div>
			</div>
			<div
				className="about-left-image-box"
				style={{ width: "100%", marginRight: 0, justifyContent: "flex-start" }}
			>
				<Box2 />
				<div className="right-paragraph">
					<p className="text">
						With the advent of the new century, I decided to present my work on
						a street more dedicated to shopping, choosing the prestigious Corso
						Magenta, still in Milan. Even in this new location, the company
						continued to attract a clientele that appreciates the exclusivity of
						handcrafted and designed jewelry.
					</p>
				</div>
			</div>
			<div
				className="about-right-image-box"
				style={{ width: "100%", marginLeft: 0 }}
			>
				<div className="mb-image">
					<ViaMazzini />
				</div>
				<div className="left-paragraph">
					<p className="text">
						Today, in my workshop in Via Giuseppe Mazzini, I continue to create
						unique jewelry with the same love, paying attention to every detail.
						My creations, once displayed in physical showcases, have evolved to
						adapt to modern times, finding space in virtual showcases on
						prestigious marketplaces, including{" "}
						<a
							href="https://www.1stdibs.com/creators/botta-gioielli/jewelry/"
							style={{ color: "black" }}
						>
							1stDibs
						</a>{" "}
						based in New York.{" "}
					</p>
					<p className="text">
						Thanks to this evolution, I have expanded my range, reaching
						customers in various Western countries, with a particular focus on
						the United States, but never forgetting my Milanese roots. <br />I
						continue to carefully follow the desires and needs of my clientele,
						both in Milan and beyond national borders, passionately carrying on
						the goldsmith tradition that has made my brand unique in the heart
						of Italian fashion and goldsmith art.
					</p>
				</div>
				<div className="dk-image">
					<ViaMazzini />
				</div>
			</div>
		</div>
	);
};

export default AboutImageGrid;
